import { isValidElement } from 'react';

import { Breakpoint } from '../../../types';
import { useBreakpoint } from '../../../hooks/useBreakpoint';
import { Flex } from '../../../GlobalComponents/Flex';

export type TwoColumnProps = {
	sidebar?: JSX.Element;
	title?: string | JSX.Element;
	breakpoint: Breakpoint;
	wrapper?: React.HTMLAttributes<HTMLDivElement>;
	children?: JSX.Element[] | JSX.Element
};

export const TwoColumn = ({ title, breakpoint, children}: TwoColumnProps) => {
	const breakpointActive = useBreakpoint(breakpoint);

	return (
		<div className={'layout-two-column w-100'}>
			{breakpointActive &&
				title &&
				(isValidElement(title) ? (
					title
				) : (
					<>
						<h1 className="text-primary font-weight-bold pt-3 mb-3">
							{title}
						</h1>
					</>
				))}
			<Flex $columnGap="36px" $margin="16px 0 0 0">
				{children}
			</Flex>
		</div>
	);
};
